import { field, date, relation, writer, children,text, json } from "@nozbe/watermelondb/decorators";
import { Model } from "@nozbe/watermelondb";
import { PAYMENT_SCHEMA } from "../schema";
import { sanitizeAttachments } from "../../constants";

export default class Payment extends Model {
  static table = PAYMENT_SCHEMA;

  static associations = {
    customer: { type: "belongs_to", key: "customer_id" },
    invoice: { type: "belongs_to", key: "invoice_id" },
    wallet_txns: { type: "belongs_to", key: "invoice_id" },
    business: { type: "belongs_to", key: "business_id" },
    orders: { type: "has_many", foreignKey: "payment_id" },
    txns: { type: 'belongs_to', key: 'txns_id' },
    cash_txn: { type: 'belongs_to', key: 'cash_txn_id' },
  };

  @text("external_type") external_type;
  @text("payment_mode") payment_mode;
  @text("udhaar_note") udhaar_note;
  @text("image_url") image_url;
  @field("is_synced") is_synced;
  @text("recording") recording;
  @field("amount") amount;
  @text("type") type;
  @text("category") category;

  @date("transacted_at") transacted_at;
  @date("created_at") created_at;
  @json("attachment", sanitizeAttachments) attachment;

  @relation("wallet_txns", "wallet_txns_id") wallet_txns;
  @relation("customer", "customer_id") customer;
  @relation("business", "business_id") business;
  @relation("invoice", "invoice_id") invoice;
  @relation('txns', 'txns_id') txns;
  @relation('cash_txn', 'cash_txn_id') cash_txn;

  @children("orders") orders;

  @writer async updatePayment(details) {
    await this.update((payment) => {
      payment.recording = details?.recording_uri || null;
      payment.udhaar_note = details.udhaar_note;
      payment.image_url = details.image_url;
      payment.transacted_at = details.date;
      payment.amount = details.amount;
      payment.attachment = details.attachment;
      payment.category = details.category;
    });
  };

  @writer async updatePaymentImage(url) {
    await this.update((payment) => {
      payment.image_url = url;
    });
  };

  @writer async markAsDeleted() {
    await super.markAsDeleted();
  };

  @writer async updatePaymentAttachments(attachment) {
    await this.update(payment => {
        payment.attachment = attachment;
    });
};

};
